var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputWrapper"},[_c('div',{staticClass:"InputWrapper-Label text-first-uppercase"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('div',{staticClass:"InputWrapper-Items"},_vm._l((_vm.items),function(input,index){return _c('component',_vm._b({key:index,attrs:{"on-change":_vm.handleChange}},'component',input,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }